import { Col, Row } from "antd";
import { InputStyle } from "./style";
import InputComponent from "../../../components/InputComponent";
import InputNumberComponent from "../../../components/InputNumberComponent";
import { useDocumentContext } from "../../../context/DocumentContext/DocumentContext";


const CategoryDetail = () => {
	const { docCategoryDetail } = useDocumentContext();

	return (
		<>
			<Row gutter={20}>
				<Col span={10}>
					<InputNumberComponent
						title={"Kategori No"}
						placeholder=""
						isRequired
						style={InputStyle}
						value={docCategoryDetail?.categoryNo}
						isDisabled
					/>
				</Col>
				<Col span={10}>
					<InputComponent
						title={"Kategori Adı"}
						placeholder=""
						isRequired
						style={InputStyle}
						value={docCategoryDetail?.name}
						isDisabled
					/>
				</Col>
			</Row >
		</>
	);
};

export default CategoryDetail;
